// extracted by mini-css-extract-plugin
export var tosLink = "_bz-0";